import { getPresignedUrlResponse } from '@services/common.service'
import { createContext } from 'react'
import { UploadOptions } from './types'

export default createContext<
  (options: UploadOptions) => Promise<getPresignedUrlResponse> | any
>(() => null)
